import axios from "@/lib/axios";

export type DownloadFileResourceRequestParams = {
  resourceLibraryId: string;
  resourceId: string;
};

export type DownloadFileResourceResponse = Blob;

export const downloadFileResource = (
  params: DownloadFileResourceRequestParams,
) =>
  axios.get<DownloadFileResourceResponse>(
    `/v1/resource-libraries/${params.resourceLibraryId}/resources/${params.resourceId}/download`,
    {
      responseType: "blob",
    },
  );
